/**
 * City Filter Component for Search
 *
 * Manages the city autocomplete input in the Location filter chip.
 * When a city is selected, shows the city as a deletable chip with a radius select.
 */

export function cityFilter() {
    return {
        hasCity: false,

        init() {
            const hiddenInput = this.$refs.cityHidden;
            this.hasCity = !!(hiddenInput && hiddenInput.value);

            if (this.hasCity) {
                this.$nextTick(() => window.LucideIcons?.initialize(this.$el));
            }

            // Listen for city-chosen (fired by genCityAcOptions onChooseEvent after user clicks a city)
            if (hiddenInput) {
                hiddenInput.addEventListener('city-chosen', () => {
                    this.hasCity = !!hiddenInput.value;
                    if (this.hasCity) {
                        if (this.$refs.cityDisplay && this.$refs.cityName) {
                            this.$refs.cityDisplay.textContent = this.$refs.cityName.value;
                        }
                        this.$nextTick(() => window.LucideIcons?.initialize(this.$el));
                    }
                });
            }
        },

        clearCity() {
            if (this.$refs.cityHidden) this.$refs.cityHidden.value = '';
            if (this.$refs.cityName) this.$refs.cityName.value = '';
            this.hasCity = false;
        }
    };
}
